import React from "react";
import PropTypes from "prop-types";
import ScriptTag from "@components/ScriptTag";
import { isServer } from "@lib/helpers";
import ContentEditorProductDescription from "@components/ProductPage/ProductDescription/ContentEditorProductDescription";
import StaticHTMLProductDescription from "@components/ProductPage/ProductDescription/StaticHTMLProductDescription";

const _1WorldSyncProductDescription = ({
  ean,
  contentEditorBlock,
  staticHTML,
  brand,
  productNumber,
}) => {
  if (!isServer) {
    window.ccs_cc_args = [
      // Customer part number will be your internal part number
      // for the SKU as defined in your catalog.
      // - optional
      // ["cpn", "CPN"],
      // The manufacturer name. Example: Lenovo, Cisco, Microsoft Corp.
      // - required
      ["mf", brand],
      // The manufacturer part number. Example: VM617A8#ABA.
      // - required
      ["pn", productNumber],
      // UPC or EAN code of the product being requested
      // - optional
      ["upcean", ean],
      // The unique identifier of the catalog found in My Catalogs.
      // - optional
      // ["ccid", "CATALOG_CODE"],
      // Two-letter ISO 639-1 language code that should be used.
      // Examples: en, fr, de.
      // - required
      ["lang", "ro"],
      // Two-letter ISO 3166-1 country code to use, or WW for world-wide.
      // Examples: US, DE, GB.
      // - required
      ["market", "RO"],
      ["_SKey", "9b101c81"],
      ["_ZoneId", "bad07d0c18"],
    ];
  }

  return (
    <>
      <div id="ccs-inline-content">
        {/* Fallback content gets automatically replaced on success */}
        {contentEditorBlock.length !== 0 ? (
          <ContentEditorProductDescription
            contentEditorBlock={contentEditorBlock}
            staticHTML={staticHTML}
            ean={ean}
            brand={brand}
          />
        ) : (
          <StaticHTMLProductDescription
            staticHTML={staticHTML}
            ean={ean}
            brand={brand}
          />
        )}
      </div>

      {!isServer && (
        <ScriptTag
          type="text/javascript"
          src="https://cdn.cs.1worldsync.com/jsc/h1ws.js"
          async
        />
      )}
    </>
  );
};

_1WorldSyncProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  contentEditorBlock: PropTypes.string.isRequired,
  ean: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default _1WorldSyncProductDescription;
